import React, { useEffect, useState } from "react";
import StatementHeader from "../statements/StatementHeader";
import { Statement, getNewestStatements } from "../../firebase/statements";
import { Grid, Hidden } from "@material-ui/core";
import DashboardSection from "./DashboardSection";
import NewestIcon from "./svg/icon-newest.svg";
import { useTranslation } from "react-i18next";
import StatementNavigationContainer from "../statements/StatementNavigationContainer";
import StatementNavigationButton from "../statements/StatementNavigationButton";

export default function NewestStatement() {
  const { t } = useTranslation();
  const [statements, setStatements] = useState<Statement[]>([]);
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  useEffect(() => {
    async function fetch() {
      const statements = await getNewestStatements();
      setStatements(statements);
    }
    fetch();
  }, []);

  let buttonRight;
  if (currentIndex < statements.length - 1)
    buttonRight = (
      <StatementNavigationButton
        arrowLeft={false}
        onClick={() => setCurrentIndex(currentIndex + 1)}
      >
        {t("statement.next")}
      </StatementNavigationButton>
    );

  let buttonLeft;
  if (statements.length > 0 && currentIndex > 0)
    buttonLeft = (
      <StatementNavigationButton
        arrowLeft={true}
        onClick={() => setCurrentIndex(currentIndex - 1)}
      >
        {t("statement.previous")}
      </StatementNavigationButton>
    );

  if (statements.length === 0) return null;

  return (
    <Grid container item direction="column" style={{ paddingBottom: "30px" }}>
      <Grid container item direction="column">
        <Hidden xsDown>
          <Grid container item style={{ padding: "40px 0px 24px 0px" }}>
            <DashboardSection
              title={t("dashboard_statements.newest")}
              icon={NewestIcon}
            />
          </Grid>
        </Hidden>

        <Grid container item>
          <StatementHeader
            statement={statements[currentIndex]}
            titleIsLink={true}
            statementNavigation={
              <StatementNavigationContainer
                buttonLeft={buttonLeft || undefined}
                buttonRight={buttonRight || undefined}
              />
            }
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
